import { render, staticRenderFns } from "./groupBuyingModal.vue?vue&type=template&id=2a59b1b3&scoped=true"
import script from "./groupBuyingModal.vue?vue&type=script&lang=js"
export * from "./groupBuyingModal.vue?vue&type=script&lang=js"
import style0 from "./groupBuyingModal.vue?vue&type=style&index=0&id=2a59b1b3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a59b1b3",
  null
  
)

export default component.exports